import { Component, OnInit, inject } from '@angular/core';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {menuAdmin} from './menu-admin.const';
import {menuDatavis} from './menu-datavis.const';
import {menuCandidat} from './menu-candidat.const';
import {menuPartner} from './menu-partner.const';
import {LANGUAGES} from '../../../core/consts/languages';
import {ModalConfirmationComponent} from '../modal-confirmation/modal-confirmation.component';
import {MatDialog} from '@angular/material/dialog';
import {ModalContactComponent} from '../modal-contact/modal-contact.component';
import {menuExpert} from './menu-expert.const';
import {ModalMesMandatsComponent} from '../modal-mes-mandats/modal-mes-mandats.component';
import {menuPresident} from './menu-president.const';
import {menuSuperadmin} from './menu-superadmin.const';
import {menuPatient} from './menu-patient.const';
import {menuAssociate} from './menu-associate.const';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [RouterLink, MatIcon, RouterLinkActive, MatMenuTrigger, MatMenu, MatMenuItem, TranslateModule]
})
export class NavigationComponent implements OnInit {
    authService = inject(AuthentificationService);
    private matDialog = inject(MatDialog);


    public menuData: { menu: any[]; classKey: string } = menuCandidat;
    public langue = 'fr';
    public LANGUAGES = LANGUAGES;
    public displayRole = 'Candidat';
    public messageActualisation = 'La page va être actualisée, pensez à enregistrer vos information si vous êtes en train de saisir des données.';
    public modalClassConfiguration = {panelClass: 'arc-dialog-panel', backdropClass: 'arc-dialog-backdrop'};
    public messageOui = 'Oui';
    public messageNon = 'Non';
    public mesMandats = 0;
    public subChild = null;

    constructor() {

        if (this.authService.isSuperAdmin()) {
            this.menuData = menuSuperadmin as any;
            this.displayRole = 'Superviseur';
        } else if (this.authService.isAdmin()) {
            this.menuData = menuAdmin as any;
            this.displayRole = 'Admin';
        } else if (this.authService.isPresident()) {
            this.menuData = menuPresident as any;
            this.displayRole = 'President / Vice-Pres.';
        } else if (this.authService.isExpert()) {
            this.menuData = menuExpert as any;
            this.displayRole = 'Expert';
        } else if (this.authService.isDataVis()) {
            this.menuData = menuDatavis as any;
            this.displayRole = 'Data Vis.';
        }else if (this.authService.isPartner()) {
            this.menuData = menuPartner as any;
            this.displayRole = 'Partner';
        }else if (this.authService.isPatient()) {
            this.menuData = menuPatient as any;
            this.displayRole = 'Patient';
        }else if (this.authService.isAssociate()) {
            this.menuData = menuAssociate as any;
            this.displayRole = 'Associate';
        }

        this.langue = this.authService.getLangueForUser();
        this.mesMandats = this.authService.userConnected.mandats.length;
    }

    public testLinksActive(paths: { url; label }[], exactMatch = false) {

        const currentPath = window.location.pathname;

        if(paths.some((item) =>  currentPath == item.url)){
            return true;
        }

        if (!exactMatch) {
            return paths.some(item => currentPath.indexOf(item.url + '/') != -1);
        }

        return false;
    }

    public setLangue(code) {
        const dialog = this.matDialog.open(ModalConfirmationComponent, {
            data: {
                content: this.messageActualisation,
                confirm: this.messageOui,
                cancel: this.messageNon
            },
            ...this.modalClassConfiguration
        });
        dialog.afterClosed().subscribe(res => {
            if (res) {this.authService.setLangueForUser(code);}
        });
    }

    public logout() {
        this.authService.logout();
    }

    public contact(): void {
        this.matDialog.open(ModalContactComponent, {
            width: '72vh',
            panelClass: 'arc-dialog-panel',
            backdropClass: 'arc-dialog-backdrop',
        });
    }

    public mesMandatsDetails() {
        this.matDialog.open(ModalMesMandatsComponent, {
            width: '72vh',
            panelClass: 'arc-dialog-panel',
            backdropClass: 'arc-dialog-backdrop',
            autoFocus: false
        });
    }

    public showChildren(link) {
        if(link === null) {
            this.subChild = null;
        } else {
            this.subChild = link.label;
        }
    }

    ngOnInit() {
    }

    public getCurrentLanguage() {
        return this.authService.getLangueForUser();
    }

}
